import React, { useState } from 'react';
import { ScanBarcode, Search as SearchIcon } from 'lucide-react';
import { BarcodeScannerModal } from '@/components/BarcodeScanner/BarcodeScannerModal';
import * as S from './styles';

type BarcodeSearchInputProps = {
    value: string;
    onChange: (value: string) => void;
    onSearch?: (value: string) => void;
    placeholder?: string;
};

export const BarcodeSearchInput = ({
    value,
    onChange,
    onSearch,
    placeholder = 'Buscar por nome ou código de barras',
}: BarcodeSearchInputProps) => {
    const [scannerOpen, setScannerOpen] = useState(false);

    return (
        <>
            <S.SearchGroup>
                <S.SearchInput
                    allowClear
                    prefix={<SearchIcon size={16} />}
                    placeholder={placeholder}
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    onPressEnter={() => onSearch?.(value)}
                />
                <S.ScanButton
                    type="button"
                    title="Ler código de barras com a câmera"
                    onClick={() => setScannerOpen(true)}
                >
                    <ScanBarcode size={18} />
                </S.ScanButton>
            </S.SearchGroup>

            <BarcodeScannerModal
                open={scannerOpen}
                onClose={() => setScannerOpen(false)}
                onDetected={(code) => {
                    onChange(code);
                    onSearch?.(code);
                    setScannerOpen(false);
                }}
            />
        </>
    );
};

export default BarcodeSearchInput;
